import { FormattedMessage, useIntl } from 'react-intl';
import styles from './layout.module.css';

export function InvoiceNotFound(): React.ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.container} data-test-error-page>
      <img
        alt={formatMessage({ id: 'error-states.not-found.title' })}
        className={styles.image}
        data-test-not-found-error-illustration
        src="/illustrations/error_state.svg"
      />
      <div className={styles.textContainer}>
        <h1 className="title-2 mb-16" data-test-not-found-error-title>
          <FormattedMessage id="error-states.not-found.title" />
        </h1>
        <p className="body-1" data-test-not-found-error-subtitle>
          <FormattedMessage id="error-states.not-found.subtitle" />
        </p>
      </div>
    </div>
  );
}
